import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FieldArray } from "react-final-form-arrays";

import { Button, colorFirm } from "../../Buttons/Button/Button";

import { FieldGroupItem } from "./FieldGroupItem/FieldGroupItem";
import "./FieldGroup.scss";

export const FieldGroup = ({
    suffixNameGroup,
    className,
    classNameLabel,
    classNameBtn,
    classNameField,
    classNameAttachedGroups,
    nameGroup,
    withIndex,
    fieldsProps,
    attachedGroups,
    fieldGroupInitialValues = {},
    push,
    label,
    onClearRow,
    onAddRow,
    customStyles,
    hideAddButton = false,
    hideLabel = false,
    hideDeleteRowButton = false,
    addButtonLabel = ""
}) => {
    const currentGroupName= `${nameGroup}${suffixNameGroup || suffixNameGroup === 0 ? "-" + suffixNameGroup : ""}`;

    return (
        <div className={"field-group"}>
            {
                !hideLabel && (
                    <div className={classNames("field-group__title", classNameLabel)}>{label}</div>
                )
            }

            <FieldArray name={currentGroupName}>
                {({ fields }) =>
                    fields.map((name, indexGroupItem) => (
                        <div key={name}>
                            <FieldGroupItem
                                className={className}
                                name={name}
                                withIndex={withIndex}
                                index={indexGroupItem}
                                fieldsProps={fieldsProps}
                                customStyles={customStyles}
                                classNameField={classNameField}
                                classNameBtn={classNameBtn}
                                fields={fields}
                                onClearRow={onClearRow}
                                hideDeleteRowButton={hideDeleteRowButton}
                            />

                            <div className={classNames("attached-groups", classNameAttachedGroups)} >
                                {
                                    attachedGroups.length ? attachedGroups.map(({ groups, isShowAttachedGroups }) => {
                                        if(isShowAttachedGroups(fields?.value[indexGroupItem])){
                                            return groups.map(({ component , ...restProps }, indexAttachedGroup)=>(
                                                component ?
                                                    component(indexAttachedGroup, indexGroupItem) :
                                                    <FieldGroup
                                                        key={indexAttachedGroup}
                                                        suffixNameGroup={indexGroupItem}
                                                        {...restProps}
                                                    />
                                            ));
                                        }

                                        return null;
                                    }): null
                                }
                            </div>
                        </div>
                    ))
                }
            </FieldArray>
            {
                !hideAddButton && (
                    <Button
                        className={"field-group-btn"}
                        type="button"
                        colorFirm={colorFirm.firm2}
                        onClick={() => onAddRow ? onAddRow() : push(
                            currentGroupName,
                            fieldGroupInitialValues
                        )}
                    >
                        {addButtonLabel ? addButtonLabel : `Add ${label}`}
                    </Button>
                )
            }
        </div>
    );
};

FieldGroup.defaultProps = {
    nameGroup: "group",
    data: [],
    attachedGroups: [],
    withIndex: true
};

FieldGroup.propTypes = {
    nameGroup: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired
};
